import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { authenticatedRoute } from '@/router/authenticated-route';
import { requireWorkspace } from '@/router/require-workspace';
import CandidateProfilePage from '@/features/candidates/candidate-profile/CandidateProfilePage';

/**
 * EU-594 — "Perfil do Candidato": destino do "Acessar perfil completo" no
 * drawer Detalhes da job-flow. Workspace-scoped como as demais páginas
 * internas: `?companyId=` viaja na URL e o guard devolve pra Home quando a
 * área de trabalho nunca foi selecionada (mesma receita de /programas).
 */
const CandidateProfileSearchSchema = z
  .object({
    companyId: z.string().uuid().optional().catch(undefined),
  })
  .strip();

export const candidateProfileRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/candidatos/$userId',
  validateSearch: CandidateProfileSearchSchema,
  beforeLoad: requireWorkspace,
  component: CandidateProfilePage,
});
